import React from "react";
import { toast } from "react-toastify";
import { Form, Card, Button, Spinner } from "react-bootstrap";
import Joi from "joi-browser";
import FormComponent from "./common/formComponent";
import { verifyEmail } from "../services/authService";

class EmailVerification extends FormComponent {
  state = {
    data: { email: "" },
    token: "",
    errors: {},
    processing: false,
  };

  schema = {
    email: Joi.string().email().required().label("Email"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      const { data: token } = await verifyEmail(this.state.data);
      this.setState({ token });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  render() {
    const { data, errors, processing, token } = this.state;

    return (
      <Card className="col-md-4 mt-5 mx-auto" id="login">
        <Card.Body>
          {!token._id && (
            <Form onSubmit={this.handleSubmit}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Enter your email address to reset password</Form.Label>
                <Form.Control
                  name="email"
                  onChange={this.handleChange}
                  value={data.email}
                  size="sm"
                  type="email"
                  autoFocus
                  autoComplete="off"
                  placeholder="Enter email"
                />
                {errors.email && <span className="text-danger">{errors.email}</span>}
                <Form.Text className="text-muted">We'll never share your email with anyone else.</Form.Text>
              </Form.Group>

              <Button disabled={this.validate() || processing} type="submit" className="main-color-bg" block>
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Reset Password
              </Button>
            </Form>
          )}

          {token._id && (
            <span>
              A link to reset your password has been sent to <b>{data.email}</b>. Please check your inbox for the link,
              it will expire in 1 hour
            </span>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default EmailVerification;
